const MapeoDeIds = {
  'Pendiente': 'Pendiente',
  'Aprobada': 'Aprobada',
  'Rechazada': 'Rechazada',
  'Pendiente Aprobación TL': 'Pendiente',
  'Rechazada a Modificar': 'Pendiente'
};

// Método para obtener el valor de cadena a partir del id
function obtenerValorEstadoFactura(estado) {
  const valorString = MapeoDeIds[estado];
  if (valorString === undefined) {
    return 'Pendiente';
  }
  return valorString;
}

export { obtenerValorEstadoFactura }